import { RoundedCheckboxChecked } from '@components/RoundedCheckboxIcons/RoundedCheckboxChecked';
import { RoundedCheckboxIndeterminate } from '@components/RoundedCheckboxIcons/RoundedCheckboxIndeterminate';
import { RoundedCheckboxUnchecked } from '@components/RoundedCheckboxIcons/RoundedCheckboxUnchecked';
import { Checkbox, CheckboxProps } from '@mui/material';
import classNames from 'classnames';
import css from './DataTable.module.scss';

/** The square is drawn inside a larger click target, never as an unclickable CSS border. */
export function TableCheckbox({ className, ...props }: CheckboxProps) {
  return (
    <Checkbox
      {...props}
      className={classNames(css.tableCheckbox, className)}
      icon={<RoundedCheckboxUnchecked />}
      checkedIcon={<RoundedCheckboxChecked />}
      indeterminateIcon={<RoundedCheckboxIndeterminate />}
    />
  );
}
